import React from 'react';

const MyReview = () => {
    return (
        <div>
            <h2>My review</h2>
        </div>
    );
};

export default MyReview;